import { Chip, Grid2, Paper, Typography } from '@mui/material';
import React, { FC } from 'react';
import * as Yup from 'yup';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { CreateArtsUseCase } from '../../../Usecase/Arts/create-arts-usecase';
import { ShowArtsUseCase } from '../../../Usecase/Arts/show-arts-usecase';
import { useCreateArts } from './arts-create.hook';
import SelectCustomerVariant from '../../../Components/Modals/variants/select-customer/select-customer-variant.component';
import { ListCustomersUseCase } from '../../../Usecase/Customers/list-customers-usecase';
import SelectProductVariant from '../../../Components/Modals/variants/select-product/select-product-variant.component';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { ShowCustomersUseCase } from '../../../Usecase/Customers/show-customers-usecase';
import { ShowProductUseCase } from '../../../Usecase/Products/show-product-usecase';


interface ProductProps {
    name: string;
    code: string;
    ncm: string;
    personalized: boolean
    createOnNuvemShop: boolean;
    createOnOmie: boolean;
    createOnb2b: boolean;
    createOnb2c: boolean;
    price: string
    description: string
  }
  
  
const SignInSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    code: Yup.string(),
    ncm: Yup.string(),
    personalized: Yup.boolean(),
    createOnNuvemShop: Yup.boolean(),
    createOnOmie: Yup.boolean(),
    price: Yup.string().required('Preço Unitário é obrigatório'),
    description: Yup.string(),
    createOnb2b: Yup.boolean(),
    createOnb2c: Yup.boolean(),
  });



  interface IArtFormProps {
    createArtsUseCase: CreateArtsUseCase
    showArtsUseCase: ShowArtsUseCase
    listCustomersUseCase: ListCustomersUseCase
    listProductsUseCase: ListProductUseCase
    showCustomersUseCase: ShowCustomersUseCase
    showProductUseCase: ShowProductUseCase
    // updateArtsUseCase: UpdateArtsUseCase
  }
const ArtForm : FC<IArtFormProps> = ({ createArtsUseCase, showArtsUseCase, listCustomersUseCase, listProductsUseCase, showCustomersUseCase, showProductUseCase  }) => {

    const {handleAction, handleSubmit, loading, register,setShowCustomersModal, showCustomersModal, errors, data, customerSelected, setCustomerSelected, handleSelectCustomer, handleSelectProduct,
        setShowProductsModal,
        showProductsModal, productSelected } = useCreateArts({
        createArtsUseCase,
        showArtsUseCase,
        showCustomersUseCase,
        showProductUseCase
    })

    
    return (
        <BaseScreen>
        {showCustomersModal && <SelectCustomerVariant data={[]} onClose={() => setShowCustomersModal(false)} onSearch={() => {}} onSelect={handleSelectCustomer} listCustomersUseCase={listCustomersUseCase} />}

        {showProductsModal && <SelectProductVariant data={[]} onClose={() => setShowProductsModal(false)} onSearch={() => {}} onSelect={handleSelectProduct} listProductsUseCase={listProductsUseCase} />}
         
            <Paper >
                <BaseContentPage 
                    title='Artes'
                    breadcrumb={[{ title: 'Artes', link: "/arts-form"}, { title: 'Nova Arte'}]}
                >

                {loading && <Loader />}

                <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>


                <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Cliente</Typography>
                    <Grid2 size={12} container sx={{
                        width: '100%',
                        padding: '20px',
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        marginTop: -4
                    }}>
                      

                        <Grid2 size={12} container spacing={2}>
                            {!!customerSelected?.id ?  <Chip   
                                label={customerSelected?.name} 
                                onDelete={() => setCustomerSelected(undefined)} 
                                sx={{ fontSize: '14px'}}
                            /> : <Typography>Nenhum cliente selecionado.</Typography>}
                        
                        </Grid2>

                    <Grid2 size={12}>
                    <Button onClick={() => setShowCustomersModal(true)} sx={{ width: '300px' }} isLoading={loading}>
                        Selecionar Cliente
                    </Button>
                    </Grid2>

                </Grid2>


                <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Produto</Typography>
                    <Grid2 size={12} container sx={{
                        width: '100%',
                        padding: '20px',
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        marginTop: -4
                    }}>
                      

                        <Grid2 size={12} container spacing={2}>
                            {!!productSelected?.id ?  <Chip   
                                label={productSelected?.name} 
                                onDelete={() => setCustomerSelected(undefined)} 
                                sx={{ fontSize: '14px'}}
                            /> : <Typography>Nenhum produto selecionado.</Typography>}
                        
                        </Grid2>

                    <Grid2 size={12}>
                    <Button onClick={() => setShowProductsModal(true)} sx={{ width: '300px' }} isLoading={loading}>
                        Selecionar Produto
                    </Button>
                    </Grid2>

                </Grid2>

                <Grid2 size={12}>
                        <Input
                            label="URL da Arte"
                            placeholder="Preencha com a url da arte"
                            error={!!errors.artLink}
                            helperText={errors.artLink?.message}
                            {...register('artLink')}
                        />
                    </Grid2>

                
              

                <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                    SALVAR
                </Button>
                </Grid2>

              </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
    )
}

export { ArtForm };
